<template>
  <img v-bind="$attrs" :src="avatar" @error="handleError"/>
</template>

<script>
import Global from '@/global'
import defAvatar from '@/assets/def-avatar.png'
export default {
  name: 'UserAvatar',
  props: {
    userAvatar: {
      type: String,
      default: null
    },
  },
  computed: {
    avatar() {
      if (this.userAvatar) {
        return Global.resolvePath(this.userAvatar)
      }
      return defAvatar
    },
  },
  methods: {
    handleError(ev) {
      ev.target.src = defAvatar
    },
  },
}
</script>

<style scoped lang="scss">
img, .svg-icon {
  width: 1em;
  height: 1em;
  border-radius: 4px;

  &.round {
    border-radius: 0.5em;
  }
}

</style>
